import { ReactNode } from 'react';
import * as Styled from './styles';

type RedirectFooterProps = {
  children: ReactNode;
  handleRedirect: () => void;
};

export const RedirectFooter = ({
  children,
  handleRedirect
}: RedirectFooterProps) => (
  <Styled.RedirectFooter onClick={handleRedirect}>
    {children}
  </Styled.RedirectFooter>
);
